<template>
  <div class="text-meta helpical-ckeditor" :class="{'helpical-ckeditor-full': full}">
    <ckeditor :editor="Editor" :config="config" v-model="model" @ready="editorReady" />
    <file-browser v-if="full" ref="fileBrowserRef" @choose="putImage"></file-browser>
  </div>
</template>

<script setup>
import fileBrowser from './fileBrowser/index.vue'
import { component as ckeditor } from '@ckeditor/ckeditor5-vue';
import Editor from './ckeditor.js';

const {
    full = false
} = defineProps({full: Boolean});

const config = full ? { language: 'fa' } : {
    removePlugins: [
		// 'Alignment',
		'AutoImage',
		// 'AutoLink',
		// 'Autoformat',
		'BlockQuote',
		// 'Bold',
		'CodeBlock',
		// 'DataFilter',
		// 'DataSchema',
		// 'DocumentListProperties',
		// 'Essentials',
		'FindAndReplace',
		// 'FontBackgroundColor',
		// 'FontColor',
		'FontSize',
		// 'GeneralHtmlSupport',
		'Heading',
		'HorizontalLine',
		'HtmlComment',
		'HtmlEmbed',
		'Image',
		'ImageCaption',
		'ImageInsertViaUrl',
		'ImageResize',
		'ImageStyle',
		'ImageToolbar',
		'Indent',
		'IndentBlock',
		// 'Italic',
		// 'Link',
		'LinkImage',
		// 'Paragraph',
		'PasteFromOffice',
		'RemoveFormat',
		'ShowBlocks',
		'SourceEditing',
		'Strikethrough',
		'Subscript',
		'Superscript',
		'Table',
		'TableCaption',
		'TableCellProperties',
		'TableColumnResize',
		'TableProperties',
		'TableToolbar',
		'TextTransformation',
		'TodoDocumentList',
		// 'Underline',
		'WordCount',
		// 'Direction',
		'Filebrowser',
    ],
    toolbar: {
        items: [
            'fontColor',
            'fontBackgroundColor',
            'bold',
            'italic',
            'underline',
            '|',
            'direction',
            'alignment',
            'bulletedList',
            'numberedList',
            'link',
        ]
    },
    language: 'fa'
};
const fileBrowserRef = useTemplateRef('fileBrowserRef');
const model = defineModel();
let editorRef = false;

function editorReady(editor) {
  editorRef = editor;
  if (full)
    editorRef.on('filebrowserOpen', () => fileBrowserRef.value.open());
}
function putImage(url) {
  editorRef.execute('insertImage', { source: url })
  fileBrowserRef.value.close()
  setTimeout(() => { editorRef.editing.view.focus(); }, 100);
}
function insertContent(content) {
  editorRef.model.insertContent(editorRef.data.toModel(editorRef.data.processor.toView(content)));
}
function focus() {
    editorRef.editing.view.focus();
}
defineExpose({ insertContent, focus });
</script>

<style>
.helpical-ckeditor .ck-content ul,
.helpical-ckeditor .ck-content ol {
    margin-right: 15px;
}
.helpical-ckeditor .ck-powered-by {
    display: none !important;
}
.helpical-ckeditor .ck-toolbar {
    background-color: #ecf1f5 !important;
}
.helpical-ckeditor .ck-editor {
    height: 100% !important;
    display: flex;
    flex-direction: column;
}
.helpical-ckeditor .ck-editor__main {
    flex-grow: 1;
    overflow-y: auto;
}
.helpical-ckeditor:not(.helpical-ckeditor-full) .ck-content {
    height: 200px;
}
.helpical-ckeditor.helpical-ckeditor-full .ck-content {
    height: 100%;
    min-height: 200px;
}
</style>
